module.exports = __webpack_public_path__ + "static/media/Doan_Khanh.380474c4.png";